/* eslint-disable import/prefer-default-export */
export const getFilter = state => state.events.filter;
